import { AmplitudeEvents } from '@constants/amplitude';
import { APP_ROUTE } from '@router/routes';
import { useSubscriptionFeature } from '@common/hooks';
import { ClientFeature, Inbox } from '@packlink/packlink-sdk';
import { IconNames } from '@shipengine/giger-theme';

import { AppSidebarInbox, ISidebarInbox } from './AppSidebarInbox';
import { inboxesStyles, sidebarStyles } from './AppSidebarStyles';
import { AppSidebarItem } from './AppSidebarItem';

const inboxesToRender: ISidebarInbox[] = [
    { inbox: Inbox.ALL },
    {
        inbox: Inbox.PENDING,
        childrenInbox: [{ inbox: Inbox.READY_TO_PURCHASE }, { inbox: Inbox.DRAFT }],
    },
    { inbox: Inbox.PROCESSING },
    { inbox: Inbox.READY_FOR_SHIPPING },
    {
        inbox: Inbox.TRACKING,
        childrenInbox: [
            { inbox: Inbox.IN_TRANSIT },
            { inbox: Inbox.OUT_FOR_DELIVERY },
            { inbox: Inbox.DELIVERED },
            { inbox: Inbox.INCIDENT },
            { inbox: Inbox.RETURNED_TO_SENDER },
        ],
    },
    { inbox: Inbox.CANCELED },
    { inbox: Inbox.ARCHIVED },
];

export function AppSidebar(): JSX.Element {
    const { feature: userAnalyticsFeature, isTenantSubscriptionEnabled } = useSubscriptionFeature(
        ClientFeature.USER_ANALYTICS,
    );

    return (
        <aside css={sidebarStyles}>
            <ul css={inboxesStyles}>
                {isTenantSubscriptionEnabled && (
                    <AppSidebarItem
                        name="subscriptions.settings.title"
                        to={APP_ROUTE.SUBSCRIPTIONS.INDEX}
                        icon={IconNames.UPGRADE}
                        event={AmplitudeEvents.SUBSCRIPTION_PLAN}
                        showNewTag
                    />
                )}
                {userAnalyticsFeature.isAvailable && (
                    <AppSidebarItem
                        name="analytics.menu.title"
                        to={APP_ROUTE.ANALYTICS.INDEX}
                        icon={IconNames.ANALYTICS}
                        event={AmplitudeEvents.ANALYTICS}
                        isItemLocked={isTenantSubscriptionEnabled && !userAnalyticsFeature.isEnabled}
                    />
                )}
                {inboxesToRender.map((inboxItem: ISidebarInbox) => (
                    <AppSidebarInbox key={inboxItem.inbox} {...inboxItem} />
                ))}
            </ul>
        </aside>
    );
}
